module.exports = "<div class=\"material-editor__languages\">\n    <select class=\"form-control\"\n        ng-model=\"vm.language\"\n        ng-model-options=\"{ getterSetter: true }\">\n        <option ng-repeat=\"(index, material) in vm.materials\"\n            ng-if=\"vm.isLanguageShown({ language: material.lang })\"\n            value=\"{{ material.lang }}\">\n            {{ vm.getLabel({ index: index }) }}\n        </option>\n    </select>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/courses/authoringTool/editor/languageSelect/template.html
// module id = 1629
// module chunks = 0